<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-title>
      <!-- leaving this here as I don't have time to pull out the business name -->
      <!-- This should turn into using the `<glxy-page-nav-button>` and `<glxy-page-title>` in the futute -->
      <sales-ui-nav-breadcrumbs [breadCrumbs]="breadCrumbs$ | async"></sales-ui-nav-breadcrumbs>
    </glxy-page-title>
  </glxy-page-toolbar>

  <ng-container *ngIf="product$ | async as product">
    <store-product-details
      [product]="product"
      [showPricing]="shouldShowPrice$ | async"
      [showActionButton]="false"
      [appPrice]="appPrice$ | async"
      [partnerCurrency]="partnerCurrency$ | async"
      [hasVerifiedContract]="true"
      [loaded]="isLoaded$$ | async"
    ></store-product-details>
  </ng-container>
</glxy-page>
